import { Button, Input, Select, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import api from "../../apis/axiosInterceptor";
import allImgPaths from "../../assets";
import { useAppState } from "../../context";

const { Option } = Select;
const { Text, Title } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const { updateState } = useAppState("auth");
  const [memberData, setMemberData] = useState([]);
  const [dropdownValue, setDropdownValue] = useState<string | undefined>();
  const [selectedMember, setSelectedMember] = useState<any>(null);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [generatedOtp, setGeneratedOtp] = useState<string>("");
  const [resendTimer, setResendTimer] = useState(100);
  const [canResend, setCanResend] = useState(false);

  const inputRefs: any = useRef<Array<HTMLInputElement | null>>([]);
  console.log("generatedOtp => ", generatedOtp);

  // const { handleSubmit, setError } = useForm({
  //   defaultValues: {
  //     username: "",
  //     password: "",
  //     invalidInput: "",
  //   },
  //   mode: "all",
  //   reValidateMode: "onChange",
  //   resolver: yupResolver(LoginFormSchema),
  // });

  /*  useEffect(() => {
    if (size(dropdownValue) > 0) {
      updateState({ memberId: dropdownValue });
    }
  }, [dropdownValue]);
 */
  const getMember = async () => {
    try {
      const result: any = await api.get(`/api/members`);

      if (result.data.status) {
        setMemberData(result.data.data);
      }
    } catch (error: any) {
      console.error("Error fetching members:", error);
    }
  };

  useEffect(() => {
    getMember();
  }, []);

  useEffect(() => {
    let interval: any;

    if (otpSent && !canResend) {
      interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanResend(true);
            return 100;
          }

          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [otpSent, canResend]);

  // const onSubmit = (data: any) => {
  //   if (checkLoginUser(data.email, data.password)) {
  //     // Login logic
  //   } else {
  //     setError("invalidInput", {
  //       type: "custom",
  //       message: "Invalid email and password input",
  //     });
  //   }
  // };

  const handleDropdownChange = async (value: string) => {
    setDropdownValue(value);
    console.log("value :>> ", value);

    setOtpSent(false);
    setOtp(Array(6).fill(""));
    try {
      const result: any = await api.get(`/api/members/${value}`);
      setSelectedMember(result.data.data);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleSendOtp = async () => {
    if (!selectedMember) return;

    setOtpSent(true);
    setCanResend(false);
    setResendTimer(100);

    try {
      const result: any = await api.post(`/api/members/generate-otp`, {
        mobileNo: selectedMember.mobileNo,
      });
      const otpStr = result.data.generatedOtp?.toString() || "";
      // const otpArray = otpStr.padEnd(6, " ").split("").slice(0, 6);

      // setOtp(otpArray);
      setGeneratedOtp(otpStr);

      console.log("Generated OTP:", otpStr);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");
    console.log("enteredOtp", enteredOtp);

    if (enteredOtp.length < 6) {
      alert("Please enter a 6-digit OTP.");
      return;
    }

    // 🔐 You can hit the verify OTP API here
    try {
      const result = await api.post("/api/members/verify-otp", {
        mobileNo: selectedMember.mobileNo,
        otp: Number(enteredOtp),
      });
      console.log("result for Login => ", result.data);

      if (result.data.status) {
        updateState({ isLoggedIn: true, memberId: dropdownValue });

        const token = result.data.accessToken;
        console.log("token => ", token);

        sessionStorage.setItem("token", token);
        sessionStorage.setItem("memberId", dropdownValue || "");
        navigate("/profile");
      } else {
        toast.error("Invalid OTP");
      }
    } catch (err) {
      console.error("OTP verification failed:", err);
      alert("Verification failed.");
    }
  };
  const handleOtpChange = (value: string, index: number) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Only last digit
    setOtp(newOtp);

    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-[300px] sm:max-w-[600px] sm:border sm:border-gray-300 sm:shadow-md sm:rounded-md p-4 sm:p-[40px] flex flex-col items-center space-y-6 bg-[#f8f8f8] sm:min-w-[400px] min-w-[359px]">
        {/* Logo above the form */}
        <div className="w-full flex justify-center mb-4">
          <img
            src={allImgPaths.bniLogoImg}
            alt="Logo"
            className="w-[110px] sm:w-[150px]"
          />
        </div>
        <div className="w-full">
          <form className="mx-auto bg-white border rounded-lg shadow-md p-6">
            <Title level={4} className="mb-4 text-center">
              Gains Profile
            </Title>

            <div className="mb-4">
              <label className="block mb-1 text-base font-semibold">
                Members
              </label>
              <Select
                showSearch
                placeholder="Select a member"
                optionFilterProp="children"
                onChange={handleDropdownChange}
                value={dropdownValue}
                filterOption={(input, option) =>
                  (option?.children as any)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                className="w-full"
              >
                {memberData.map((member: any) => {
                  const toTitleCase = (str: string) =>
                    str
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1),
                      )
                      .join(" ");

                  const formattedName = toTitleCase(member.memberName);

                  return (
                    <Option key={member._id} value={member._id}>
                      {formattedName}
                    </Option>
                  );
                })}
              </Select>
            </div>

            {selectedMember && (
              <div className="mb-4">
                <Text className="block mb-1 text-base font-semibold">
                  Mobile Number : {selectedMember.mobileNo}
                </Text>
                <Button type="primary" className="mt-2" onClick={handleSendOtp}>
                  Send OTP
                </Button>
              </div>
            )}

            {otpSent && (
              <div className="mt-4">
                <Text className="block mb-2">Enter OTP</Text>
                <div className="flex gap-2 mb-3">
                  {otp.map((digit, index) => (
                    <Input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      value={digit}
                      onChange={(e) => handleOtpChange(e.target.value, index)}
                      maxLength={1}
                      className="text-center w-10 h-10"
                    />
                  ))}
                </div>
                <div className="flex items-center gap-4">
                  <Button type="primary" onClick={handleVerifyOtp}>
                    Verify OTP
                  </Button>

                  <Text
                    className={`font-semibold ${
                      canResend
                        ? "text-blue-600 hover:underline cursor-pointer"
                        : "text-gray-400 cursor-not-allowed"
                    }`}
                    onClick={canResend ? handleSendOtp : undefined}
                  >
                    {canResend ? "Resend OTP" : `Resend OTP in ${resendTimer}s`}
                  </Text>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
